import { round, sumBy } from 'lodash';
import { allocationsHelpers } from 'further-ui/domain';
import { EqualisationFormValues } from '../FormWrapper';

const recalculateLinkedActionAllocations = (
  parentAllocations: EqualisationFormValues['actions'][number]['newAllocations'],
  linkedActionTotalAmountLcy: number,
  includedCommitments: Array<{
    _id: string;
    isBalancingEntity: boolean;
    totalCommitmentLcy: number;
  }>,
) => {
  const parentAllocationsTotalPercentage = round(
    sumBy(parentAllocations, (allocation) => allocation.allocationPercentage),
    5,
  );

  const initialAllocations = parentAllocations.map((allocation) => ({
    commitmentId: allocation.commitmentId,
    allocationAmountLcy:
      linkedActionTotalAmountLcy === 0
        ? 0
        : round(
            (allocation.allocationPercentage / 100) *
              linkedActionTotalAmountLcy,
            2,
          ),
    allocationAmountTcy: 0,
    allocationPercentage: allocation.allocationPercentage,
    excludeFromAllocation: allocation.excludeFromAllocation,
  }));

  if (parentAllocationsTotalPercentage === 100) {
    allocationsHelpers.balanceAllocations({
      allocations: initialAllocations,
      includedCommitments,
      targetAmount: linkedActionTotalAmountLcy,
      valueToBalance: 'allocationAmountLcy',
    });
  }

  return initialAllocations;
};

export default recalculateLinkedActionAllocations;
